import { request } from './client';
import type { GuestSession } from './types';

/**
 * Exchanges the short code from a scanned QR for a session scoped to one check.
 *
 * The API answers a flat 404 for an unknown code, an expired one, and a code whose check has since closed.
 * They are indistinguishable on purpose — telling them apart tells a guesser which codes exist — so the UI
 * has one message for all three.
 */
export function createSession(code: string, signal?: AbortSignal): Promise<GuestSession> {
    return request<GuestSession>('/sessions', { method: 'POST', body: { code }, signal });
}
